import React, { Component } from 'react';
import DateTimePicker from 'react-datetime-picker';

import './CalendarDateTimePicker.css';

class CalendarDateTimePicker extends Component {

  handleOnChange = (date) => {
    const { name } = this.props;

    this.props.onChange({
      [name]: date
    });
  }

  render() {
    const { value, format = 'dd/MM/yyyy HH:mm', calendarIcon, clearIcon = null, minDate = null, maxDate = null } = this.props;

    return (
      <div>
        <DateTimePicker
          format={ format }
          showLeadingZeros={ true }
          value={ value }
          clearIcon={ clearIcon }
          calendarIcon={ calendarIcon }
          minDate={ minDate }
          maxDate={ maxDate }
          disableClock={ true }
          onChange={ this.handleOnChange }
        />
      </div>
      );
    }
  }

export default CalendarDateTimePicker;